export const matchDisplayName = (childRef, displayName) => {
  return (
    (childRef &&
      childRef.type &&
      childRef.type.render &&
      childRef.type.render.displayName &&
      childRef.type.render.displayName.indexOf(displayName) > -1) ||
    (childRef && childRef.type && childRef.type.displayName && childRef.type.displayName.indexOf(displayName) > -1) ||
    (childRef && childRef.type && childRef.type.name && childRef.type.name.indexOf(displayName) > -1)
  );
};
